import { createContext } from 'react'

import type { EntitiesColorsContextData } from './types'

export const EntitiesColorsContext = createContext<EntitiesColorsContextData | null>(null)
